<template>
  <div class="outer">
    <Header></Header>
    <vue-element-loading :active="loading" :is-full-screen="true" spinner="ring" />

    <div class="px-5 py-20 bg-surface-secondary d-flex flex-column justify-content-center">
      <div class="d-flex justify-content-center">
        <div
          class="col-12 col-md-9 col-lg-8 min-h-lg-screen d-flex flex-column justify-content-center py-lg-16 px-lg-20 position-relative"
        >
          <div class="row">
            <div class="col-lg-10 col-md-9 col-xl-7 mx-auto">
              <div class="text-center mb-12">
                <h1 class="ls-tight font-bolder mt-6">
                  Create your account
                </h1>
                <p class="mt-2">It's free and easy</p>
              </div>

              <div class="mb-2 row">
                <div class="inlinediv col-lg-6 col-md-12">
                  <div class="mr">
                    <label class="form-label">
                      First name<img class="asterisk" :src="imgUrls.asterisk" />
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      ref="firstName"
                      @blur="checkFirstLastName"
                      v-model.trim="firstName"
                      placeholder="First name"
                    />
                  </div>
                </div>

                <div class="inlinediv col-lg-6 col-md-12">
                  <div class="ml">
                    <label class="form-label">
                      Last name<img class="asterisk" :src="imgUrls.asterisk" />
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      ref="lastName"
                      @blur="checkFirstLastName"
                      v-model.trim="lastName"
                      placeholder="Last name"
                    />
                  </div>
                </div>

                <p class="errrorMsg" v-if="errorName">
                  Are you sure you entered your name correctly?
                </p>
              </div>

              <div class="mb-2">
                <label class="form-label" for="email">
                  Email address <img class="asterisk" :src="imgUrls.asterisk" />
                </label>
                <input
                  id="email"
                  type="email"
                  class="form-control"
                  ref="email"
                  @blur="checkEmailField"
                  v-model.trim="email"
                  placeholder="Your email"
                />
                <p class="errrorMsg" v-if="errorEmail">This email address is not valid.</p>
              </div>

              <div class="mb-2">
                <label class="form-label">
                  Job Title <img class="asterisk" :src="imgUrls.asterisk" />
                </label>
                <input
                  type="text"
                  class="form-control"
                  ref="jobTitle"
                  v-model.trim="jobTitle"
                  placeholder="Your Job Title"
                />
              </div>

              <div class="mb-2">
                <label class="form-label">
                  Institute <img class="asterisk" :src="imgUrls.asterisk" />
                </label>
                <input
                  type="text"
                  class="form-control"
                  ref="organisation"
                  v-model.trim="organisation"
                  placeholder="Your Institute"
                />
              </div>

              <div class="mb-2 row">
                <div class="inlinediv col-lg-6 col-md-12">
                  <div class="mr">
                    <label class="form-label">
                      City<img class="asterisk" :src="imgUrls.asterisk" />
                    </label>
                    <input type="text" class="form-control" v-model.trim="city" placeholder="Your City" />
                  </div>
                </div>

                <div class="inlinediv col-lg-6 col-md-12">
                  <div class="ml">
                    <label class="form-label">
                      Country<img class="asterisk" :src="imgUrls.asterisk" />
                    </label>
                    <input type="text" class="form-control" v-model.trim="country" placeholder="Your Country" />
                  </div>
                </div>
              </div>

              <div class="mb-2">
                <label class="form-label" for="password">
                  Password<img class="asterisk" :src="imgUrls.asterisk" />
                </label>
                <div class="outer">
                  <input
                    :type="passwordType"
                    class="inner form-control"
                    style="width: 90%;"
                    ref="password"
                    @blur="checkPasswordField"
                    v-model.trim="password"
                    placeholder="Password"
                    autocomplete="current-password"
                  />
                  <img class="eyes" :src="eyesImage" @click="clickEyes" />
                </div>
                <p class="errrorMsg" v-if="errorPw">Incorrect password format</p>
                <p style="font-size: xx-small; color: rgba(107,123,147);">Use 6 ~ 20 characters.</p>
              </div>

              <div class="mb-2">
                <label class="form-label" for="confirm">
                  Confirm Password<img class="asterisk" :src="imgUrls.asterisk" />
                </label>
                <div class="outer">
                  <input
                    id="confirm"
                    :type="passwordType"
                    class="inner form-control"
                    style="width: 90%;"
                    ref="confirm"
                    @blur="confirmPw"
                    v-model.trim="confirm"
                    placeholder="Confirm"
                    autocomplete="current-password"
                  />
                  <img class="eyes" :src="eyesImage" @click="clickEyes" />
                </div>
                <p class="errrorMsg" v-if="errorCon">Different passwords</p>
              </div>

              <div class="mb-2">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="agree"
                    name="check_example"
                    id="check-remind-me"
                  />
                  <label class="form-check-label font-semibold text-muted">
                    By creating an account means you agree to the
                    <u class="my-a" data-bs-toggle="modal" data-bs-target="#terms">Terms and Conditions</u>, and our
                    <u class="my-a" data-bs-toggle="modal" data-bs-target="#privacy"
                      >Data Privacy Policy and Transfer Agreement</u
                    >
                  </label>
                </div>
              </div>

              <div>
                <button class="btn btn-primary w-full" @click="register" :disabled="disabledVal">
                  Register
                </button>
              </div>

              <div class="my-6">
                <small>Already have an account?</small>
                <button @click="signIn" class="text-warning text-sm font-semibold">Sign in</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- terms modal -->
    <div class="modal fade" id="terms" ref="terms" tabindex="-1" aria-labelledby="terms" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <i class="bi bi-x-lg off-x modal-off-x" data-bs-dismiss="modal"></i>
          <div class="modal-body px-12" style="padding-top: 0.5rem;">
            <h2 style="text-align: center; margin-bottom: 2rem;">{{ terms.title }}</h2>
            <ol>
              <li class="navbar-text" v-for="(content, index) in terms.contents" :key="index">{{ content }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <!-- privacy modal -->
    <div class="modal fade" id="privacy" ref="privacy" tabindex="-1" aria-labelledby="privacy" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <i class="bi bi-x-lg off-x modal-off-x" data-bs-dismiss="modal"></i>
          <div class="modal-body px-12" style="padding-top: 0.5rem; max-height: 70vh; overflow-y: auto;">
            <h2 style="text-align: center; margin-bottom: 2rem;">{{ privacy.title }}</h2>
            <p class="navbar-text" v-for="(content, index) in privacy.contents" :key="index">{{ content }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/commons/HeaderItem.vue";
import { pb } from "@/utils/pocketbase";
import { checkEmail, checkPassword, isEmpty, checkName } from "@/utils/validate";

export default {
  name: "RegisterItem",
  components: { Header },

  data() {
    return {
      imgUrls: {
        primary: "./img/logos/PGS-hub.png",
        asterisk: "./img/asterisk.png",
        prompt: "./img/prompt.png",
      },

      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirm: "",
      jobTitle: "",
      organisation: "",
      city: "",
      country: "",

      eyesImage: "./img/logos/close.png",
      passwordType: "password",
      agree: false,

      errorName: false,
      errorEmail: false,
      errorPw: false,
      errorCon: false,

      loading: false,
      eyesType: false,

      terms: { /* 你的 terms 原样保留 */ },
      privacy: { /* 你的 privacy 原样保留 */ },
    };
  },

  computed: {
    disabledVal() {
      return !this.agree || this.loading;
    },
  },

  methods: {
    // ---------- 校验 ----------
    checkFirstLastName() {
      const full = `${this.firstName || ""}${this.lastName || ""}`.trim();
      if (!isEmpty(full)) this.errorName = checkName(full);
    },

    checkEmailField() {
      if (!isEmpty(this.email)) this.errorEmail = checkEmail(this.email);
    },

    checkPasswordField() {
      if (!isEmpty(this.password)) this.errorPw = checkPassword(this.password);
    },

    confirmPw() {
      if (!isEmpty(this.password) && !isEmpty(this.confirm)) {
        this.errorCon = this.password !== this.confirm;
      }
    },

    clickEyes() {
      this.eyesType = !this.eyesType;
      if (this.eyesType) {
        this.eyesImage = "./img/logos/open.png";
        this.passwordType = "text";
      } else {
        this.eyesImage = "./img/logos/close.png";
        this.passwordType = "password";
      }
    },

    // ---------- PocketBase 注册 ----------
    async register() {
      // ====== validate ======
      if (isEmpty(this.firstName) || this.errorName) {
        alert("Please enter or modify First Name!");
        this.$refs.firstName?.focus?.();
        return;
      }
      if (isEmpty(this.lastName) || this.errorName) {
        alert("Please enter or modify Last Name!");
        this.$refs.lastName?.focus?.();
        return;
      }
      if (isEmpty(this.email) || this.errorEmail) {
        alert("Please enter or modify email address!");
        this.$refs.email?.focus?.();
        return;
      }
      if (isEmpty(this.password) || this.errorPw) {
        alert("Please enter or modify password!");
        this.$refs.password?.focus?.();
        return;
      }
      if (isEmpty(this.confirm) || this.errorCon) {
        alert("Please confirm password!");
        this.$refs.confirm?.focus?.();
        return;
      }
      if (isEmpty(this.jobTitle)) {
        alert("Please enter or modify Job Title!");
        this.$refs.jobTitle?.focus?.();
        return;
      }
      if (isEmpty(this.organisation)) {
        alert("Please enter or modify organisation!");
        this.$refs.organisation?.focus?.();
        return;
      }
      if (isEmpty(this.city)) {
        alert("Please enter or modify city!");
        return;
      }
      if (isEmpty(this.country)) {
        alert("Please enter or modify country!");
        return;
      }
      if (!this.agree) {
        alert("Please agree to Terms and Conditions.");
        return;
      }

      this.loading = true;

      try {
        // ✅ 1) PocketBase create user record
        // 注意：自定义字段必须先在 PB users collection 里创建同名字段
        const payload = {
          email: (this.email || "").trim(),
          password: this.password,
          passwordConfirm: this.confirm,

          // 如果你 PB 的 users 有 name 字段（很多模板会有），建议写一下，方便后台列表看
          name: `${this.firstName} ${this.lastName}`.trim(),

          // 自定义字段（需要你在 PB users collection 新增字段）
          firstName: this.firstName,
          lastName: this.lastName,
          jobTitle: this.jobTitle,
          organisation: this.organisation,
          city: this.city,
          country: this.country,

          // 可选：默认非管理员
          // role: "user",
        };

        const user = await pb.collection("users").create(payload);

        // ✅ 2) 可选：发送邮箱验证（要求你 PB 启用了 Require email confirmation）
        // 如果没启用，调用会报错，你可以直接注释掉
        try {
          await pb.collection("users").requestVerification(payload.email);
        } catch (e) {
          // 不阻断注册流程，只打印
          console.warn("[PB] requestVerification skipped/failed:", e?.message || e);
        }

        this.$MessageBox?.alert?.(
          "Registration successful. Please sign in.",
          "Message",
          {
            confirmButtonText: "OK",
            callback: () => this.signIn(),
          }
        );

        return user;
      } catch (err) {
        console.error("[PB Register Error]", err);

        // PocketBase 常见错误结构：
        // err.data.message / err.data.data.<field>.message
        const msg =
          err?.data?.message ||
          err?.message ||
          "Registration failed. Please try again.";

        // 如果是字段级错误，拼一条更清晰的提示
        const fieldErrors = err?.data?.data;
        if (fieldErrors && typeof fieldErrors === "object") {
          const firstField = Object.keys(fieldErrors)[0];
          const firstMsg = fieldErrors[firstField]?.message;
          if (firstMsg) {
            this.$MessageBox?.alert?.(`${firstField}: ${firstMsg}`, "Message", {
              confirmButtonText: "OK",
            });
            return;
          }
        }

        this.$MessageBox?.alert?.(msg, "Message", { confirmButtonText: "OK" });
      } finally {
        this.loading = false;
      }
    },

    signIn() {
      this.$router.push({
        name: "login",
        query: { email: this.email },
      });
    },
  },
};
</script>

<style>
.errrorMsg {
  color: #e30404;
  font-size: x-small;
}
.eyes {
  height: 1.5rem;
}
.outer {
  background-color: #fff;
  border: 1px solid #e7eaf0;
  border-radius: 0.375rem;
  box-shadow: 0 1px 2px rgb(50 50 71 / 8%);
  color: #16192c;
  display: block;
}
.inner {
  border: 0px solid #ffffff !important;
  border-radius: 0.375rem !important;
  box-shadow: 0 0px 0px rgb(255 255 255) !important;
  display: inline-block !important;
}
.inlinediv {
  display: inline-block !important;
}
.mr {
  margin-right: 0.25rem;
}
.ml {
  margin-left: 0.25rem;
}
.asterisk {
  width: 0.5rem;
}
.my-a {
  color: blue;
}
.modal-off-x {
  text-align: right;
  margin-right: 0.5rem;
  margin-top: 0.5rem;
}
.modal-dialog {
  max-width: 40rem !important;
}
</style>